import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const isQrPage = useMatch("/qr/:maskedCode");

  return (
    <>
      {["/", "/contact", "/about", "/privacy", "/terms"].includes(window.location.pathname) ? (
        <footer className="footer">
          <div className="footer-content">
            <div className="container">
              <div className="row g-4">
                {/* Company Info */}
                <div className="col-lg-4 col-md-6">
                  <div className="footer-section">
                    <div className="footer-brand">
                      <img
                        src="/images/asset7.svg"
                        alt="medhive logo"
                        style={{ height: "36px" }}
                      />
                    </div>
                    <p className="footer-description">
                      Streamlining medical education through comprehensive rotation management, 
                      evaluation systems, and work hour tracking for healthcare institutions.
                    </p>
                    <div className="social-links">
                      <a href="#" className="social-link">
                        <i className="bi bi-linkedin"></i>
                      </a>
                      <a href="#" className="social-link">
                        <i className="bi bi-twitter"></i>
                      </a>
                      <a href="#" className="social-link">
                        <i className="bi bi-facebook"></i>
                      </a>
                      <a href="#" className="social-link">
                        <i className="bi bi-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Product Links */}
                <div className="col-lg-2 col-md-6 col-sm-6 col-6">
                  <div className="footer-section">
                    <h5 className="footer-heading">Product</h5>
                    <ul className="footer-links">
                      <li><Link to="/about">About Us</Link></li>
                      <li><Link to="/features">Features</Link></li>
                      <li><Link to="/pricing">Pricing</Link></li>
                      <li><Link to="/demo">Request Demo</Link></li>
                      <li><Link to="/contact">Contact Sales</Link></li>
                    </ul>
                  </div>
                </div>

                {/* Support Links */}
                <div className="col-lg-2 col-md-6 col-sm-6 col-6">
                  <div className="footer-section">
                    <h5 className="footer-heading">Support</h5>
                    <ul className="footer-links">
                      <li><Link to="/help">Help Center</Link></li>
                      <li><Link to="/documentation">Documentation</Link></li>
                      <li><Link to="/api">API Reference</Link></li>
                      <li><Link to="/status">System Status</Link></li>
                      <li><Link to="/contact">Contact Support</Link></li>
                    </ul>
                  </div>
                </div>

                {/* Legal Links */}
                <div className="col-lg-2 col-md-6 col-sm-6 col-6">
                  <div className="footer-section">
                    <h5 className="footer-heading">Legal</h5>
                    <ul className="footer-links">
                      <li><Link to="/privacy">Privacy Policy</Link></li>
                      <li><Link to="/terms">Terms of Use</Link></li>
                      <li><Link to="/cookies">Cookie Policy</Link></li>
                      <li><Link to="/gdpr">GDPR</Link></li>
                      <li><Link to="/security">Security</Link></li>
                    </ul>
                  </div>
                </div>

                {/* Company Links */}
                <div className="col-lg-2 col-md-6 col-sm-6 col-6">
                  <div className="footer-section">
                    <h5 className="footer-heading">Company</h5>
                    <ul className="footer-links">
                      <li><Link to="/about">About</Link></li>
                      <li><Link to="/careers">Careers</Link></li>
                      <li><Link to="/blog">Blog</Link></li>
                      <li><Link to="/press">Press</Link></li>
                      <li><Link to="/partners">Partners</Link></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Bottom Section */}
              <div className="footer-bottom">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <p className="copyright">
                      © {currentYear} medhive. All rights reserved.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <div className="footer-bottom-links">
                      <Link to="/terms">Terms of Use</Link>
                      <Link to="/privacy">Privacy Policy</Link>
                      <Link to="/cookies">Cookies</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      ) : (
        <footer>
          <div className="container">
            <div className="row g-4 auto d-flex justify-content-center">
              <div className="col-9 position-relative">
                <div className={`d-flex justify-content-center ${isQrPage ? "copyright-container" : "h-100"}`}>
                  <p className="text-muted copyright-content">
                    © {currentYear} Medhive LLC. All rights reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;